module.exports=function(scope){ return `<!-- source object missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "You must pass a valid source object.",
        "subCode": "missingParameter"
    }
}

<!-- target object missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "You must pass a valid target object.",
        "subCode": "missingParameter"
    }
}

<!-- enrollmentIdentifier or faceMap missing in source or target -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "You must pass valid parameters.",
        "subCode": "missingParameter"
    }
}

<!-- sessionId missing in request -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "The request is missing the sessionId parameter. The sessionId parameter is required and can be obtained from the output of the FaceTec iOS/Android/Browser SDK. For more information, please visit https://dev.facetec.com/zoomsdk/#/webservice-guide.",
        "subCode": "missingParameter"
    }
}

<!-- Invalid sessionId -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "sessionId must be UUID in standard format.",
        "subCode": "invalidSessionId"
    }
}

<!-- invalid json -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Invalid json message received",
        "subCode": "invalidJsonReceived"
    }
}

<!-- enrollmentIdentifier not found in database -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "No entry found in the database for this enrollmentIdentifier.",
        "subCode": "targetNotFound"
    }
}

<!-- empty faceMap -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Empty string not valid for parameter FaceMap.",
        "subCode": "badStringParameter"
    }
}


<!-- Source FaceMap is less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Source data length is < 20.",
        "subCode": "unableToProcess",
    }
}

<!-- Target FaceMap is less then 20 characters -->
{
    "meta": {
        "ok": false,
        "code": 400,
        "mode": "dev",
        "message": "Target data length is < 20.",
        "subCode": "unableToProcess",
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/response/failure/compare.json.tpl